// // components/ChatWithDisclaimer.jsx
// import React, { useEffect, useContext } from "react";
// import DataDrivenChat from "../pages/DataDrivenChat/DataDrivenChat";
// import DisclaimerModal from "./DisclaimerModal/DisclaimerModal";
// import { AppContext } from "../utils/Context/AppContext";

// const ChatWithDisclaimer = () => {
//   const { disclaimerModal, setDisclaimerModal } = useContext(AppContext);

//   useEffect(() => {
//     const accepted = localStorage.getItem("disclaimerAccepted");
//     if (!accepted) {
//       setDisclaimerModal(true);
//     }
//   }, [setDisclaimerModal]);

//   if (disclaimerModal) {
//     return (
//       <DisclaimerModal
//         isOpen={disclaimerModal}
//         onClose={() => {
//           localStorage.removeItem("disclaimerAccepted");
//           setDisclaimerModal(false);
//           window.location.href = "https://www.neca.asn.au/";
//         }}
//         onAccept={() => {
//           localStorage.setItem("disclaimerAccepted", "true");
//           setDisclaimerModal(false);
//         }}
//       />
//     );
//   }

//   return <DataDrivenChat />;
// };

// export default ChatWithDisclaimer;
import React, { useEffect, useContext, useCallback } from "react";
import DataDrivenChat from "../pages/DataDrivenChat/DataDrivenChat";
import DisclaimerModal from "./DisclaimerModal/DisclaimerModal";
import { AppContext } from "../utils/Context/AppContext";

const ChatWithDisclaimer = () => {
  const { disclaimerModal, setDisclaimerModal } = useContext(AppContext);

  const hasAcceptedDisclaimer = useCallback(() => {
    return localStorage.getItem("disclaimerAccepted") === "true";
  }, []);

  const acceptDisclaimer = useCallback(() => {
    localStorage.setItem("disclaimerAccepted", "true");
    setDisclaimerModal(false);
  }, [setDisclaimerModal]);

  const rejectDisclaimer = useCallback(() => {
    localStorage.removeItem("disclaimerAccepted");
    setDisclaimerModal(false);
    window.location.href = "https://www.neca.asn.au/";
  }, [setDisclaimerModal]);

  useEffect(() => {
    if (!hasAcceptedDisclaimer()) {
      setDisclaimerModal(true);
    }
  }, [hasAcceptedDisclaimer, setDisclaimerModal]);

  if (disclaimerModal) {
    return (
      <DisclaimerModal
        isOpen={disclaimerModal}
        onClose={rejectDisclaimer}
        onAccept={acceptDisclaimer}
      />
    );
  }

  return <DataDrivenChat />;
};

export default ChatWithDisclaimer;
